import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69ea7bfa63911b0014cf14f1/lovelocals/src/app/post-job/page.tsx");
